module.exports = __webpack_public_path__ + "img/plant.fb70a7b1.png";